import React, { useState, useEffect } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import { Modal, Button } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const AsignarPlantillaClientes = () => {
    const history = useHistory();
    const { id } = useParams();
const [plantilla, setPlantilla] = useState(null);
    const [clientes, setClientes] = useState([]);
    const [clientesAsignados, setClientesAsignados] = useState([]);
    const [selectedClientes, setSelectedClientes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        fetchData();
    }, [history, id]);

    const fetchData = async () => {
        try {
            const [plantillaRes, clientesRes, asignadosRes] = await Promise.all([
                axios.get(`/superadmin/plantillas-admin/${id}`),
                axios.get('/superadmin/clientes'),
                axios.get(`/superadmin/plantillas-admin/${id}/clientes-asignados`)
            ]);

            setPlantilla(plantillaRes.data);
            setClientes(Array.isArray(clientesRes.data) ? clientesRes.data : []); // Todos los clientes
            setClientesAsignados(Array.isArray(asignadosRes.data) ? asignadosRes.data : []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            } else {
                setAlert({
                    show: true,
                    type: 'danger',
                    message: 'Error al cargar los datos'
                });
                setLoading(false);
            }
        }
    };

    const handleCheckboxChange = (clienteId) => {
        if (clientesAsignados.includes(clienteId)) {
            return; // No permitir deseleccionar clientes ya asignados
        }

        setSelectedClientes(prev => {
            if (prev.includes(clienteId)) {
                return prev.filter(id => id !== clienteId);
            } else {
                return [...prev, clienteId];
            }
        });
    };

    const handleSelectAll = () => {
        const clientesDisponibles = clientes
            .filter(c => !clientesAsignados.includes(c.id))
            .map(c => c.id);
        setSelectedClientes(clientesDisponibles);
    };

    const handleDeselectAll = () => {
        setSelectedClientes([]);
    };

    const handleAsignarClick = () => {
        if (selectedClientes.length === 0) {
            setAlert({
                show: true,
                type: 'warning',
                message: 'Debe seleccionar al menos un cliente'
            });
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000);
            return;
        }
        setShowConfirmModal(true);
    };

    const handleAsignarConfirm = async () => {
        setSubmitting(true);
        try {
            const response = await axios.post(`/superadmin/plantillas-admin/${id}/asignar-clientes`, {
                cliente_ids: selectedClientes
            });

            setAlert({
                show: true,
                type: 'success',
                message: `Se crearon ${response.data.copias_creadas} copias de la plantilla exitosamente`
            });

            // Actualizar la lista de clientes asignados
            setClientesAsignados([...clientesAsignados, ...selectedClientes]);
            setSelectedClientes([]);
            setShowConfirmModal(false);

            setTimeout(() => {
                history.push('/superadmin/plantillas');
            }, 2000);
        } catch (error) {
            console.error('Error asignando plantilla:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al asignar la plantilla'
            });
            setShowConfirmModal(false);
        } finally {
            setSubmitting(false);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const handleSincronizar = async () => {
        setSyncing(true);
        try {
            const token = localStorage.getItem('superadmin_token');
            const response = await axios.post(
                `/superadmin/plantillas-admin/${id}/sincronizar-clientes`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setAlert({
                show: true,
                type: 'success',
                message: `Se actualizaron ${response.data.copias_actualizadas} copias de la plantilla exitosamente`
            });
            setShowSyncModal(false);
        } catch (error) {
            console.error('Error sincronizando plantilla:', error);
            setAlert({
                show: true,
                type: 'danger',
                message: error.response?.data?.message || 'Error al sincronizar la plantilla'
            });
            setShowSyncModal(false);
        } finally {
            setSyncing(false);
            setTimeout(() => setAlert({ show: false, type: '', message: '' }), 5000);
        }
    };

    const getFilteredClientes = () => {
        if (!searchTerm) return clientes;
        return clientes.filter(c => {
            const nombre = (c.nombre || '').toLowerCase();
            const nit = (c.nit || '').toLowerCase();
            const search = searchTerm.toLowerCase();
            return nombre.includes(search) || nit.includes(search);
        });
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    const filteredClientes = getFilteredClientes();

    return (
        <SuperadminLayout>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4>
                                    <i className="fas fa-users"></i> Asignar Plantilla a Clientes
                                </h4>
                                <div>
                                    {clientesAsignados.length > 0 && (
                                        <button
                                            className="btn btn-warning mr-2"
                                            onClick={() => setShowSyncModal(true)}
                                            disabled={syncing}
                                        >
                                            {syncing ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                    Sincronizando...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-sync-alt"></i> Actualizar Clientes Asignados
                                                </>
                                            )}
                                        </button>
                                    )}
                                    <Link to="/superadmin/plantillas" className="btn btn-secondary">
                                        <i className="fas fa-arrow-left"></i> Volver
                                    </Link>
                                </div>
                            </div>

                            {/* Alertas */}
                            {alert.show && (
                                <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
                                    {alert.message}
                                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                            )}

                            {/* Información de la Plantilla */}
                            {plantilla && (
                                <div className="card mb-4">
                                    <div className="card-header bg-dark text-white">
                                        <h5 className="mb-0">
                                            <i className="fas fa-file-medical"></i> {plantilla.nombre}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p><strong>Especialidad:</strong> {plantilla.especialidad || 'Sin especialidad'}</p>
                                                <p><strong>Estado:</strong> 
                                                    <span className={`badge badge-${plantilla.estado === 1 ? 'success' : 'secondary'} ml-2`}>
                                                        {plantilla.estado === 1 ? 'Activa' : 'Inactiva'}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Descripción:</strong> {plantilla.descripcion || 'Sin descripción'}</p>
                                                <p><strong>Clientes asignados:</strong> {clientesAsignados.length}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Controles */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar cliente por nombre o NIT..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 text-right">
                                    <button
                                        className="btn btn-outline-dark mr-2"
                                        onClick={handleSelectAll}
                                    >
                                        <i className="fas fa-check-square"></i> Seleccionar Todos
                                    </button>
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={handleDeselectAll}
                                    >
                                        <i className="fas fa-square"></i> Deseleccionar Todos
                                    </button>
                                </div>
                            </div>

                            <div className="alert alert-info">
                                <i className="fas fa-info-circle"></i> Seleccione los clientes a los que desea asignar esta plantilla. 
                                Se creará una copia independiente para cada cliente.
                            </div>

                            {/* Lista de Clientes */}
                            <div className="card">
                                <div className="card-body">
                                    <h6 className="mb-3">
                                        Clientes Disponibles ({filteredClientes.length})
                                        {selectedClientes.length > 0 && (
                                            <span className="badge badge-dark ml-2">
                                                {selectedClientes.length} seleccionados
                                            </span>
                                        )}
                                    </h6>
                                    
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        {filteredClientes.length > 0 ? (
                                            <div className="list-group">
                                                {filteredClientes.map(cliente => {
                                                    const yaAsignado = clientesAsignados.includes(cliente.id);
                                                    const seleccionado = selectedClientes.includes(cliente.id);
                                                    
                                                    return (
                                                        <div
                                                            key={cliente.id}
                                                            className={`list-group-item ${yaAsignado ? 'list-group-item-secondary' : ''}`}
                                                        >
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={`cliente-${cliente.id}`}
                                                                    checked={yaAsignado || seleccionado}
                                                                    onChange={() => handleCheckboxChange(cliente.id)}
                                                                    disabled={yaAsignado}
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor={`cliente-${cliente.id}`}
                                                                    style={{ cursor: yaAsignado ? 'not-allowed' : 'pointer' }}
                                                                >
                                                                    <strong>{cliente.nombre}</strong>
                                                                    <br />
                                                                    <small className="text-muted">
                                                                        NIT: {cliente.nit} | Usuarios: {cliente.usuarios_actuales || 0}/{cliente.limite_usuarios}
                                                                    </small>
                                                                    {yaAsignado && (
                                                                        <span className="badge badge-success ml-2">
                                                                            <i className="fas fa-check"></i> Ya asignado
                                                                        </span>
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <p className="text-center text-muted">No se encontraron clientes</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Botones de Acción */}
                            <div className="mt-4">
                                <button
                                    className="btn btn-superadmin"
                                    onClick={handleAsignarClick}
                                    disabled={selectedClientes.length === 0 || submitting}
                                >
                                    <i className="fas fa-check"></i> Asignar a {selectedClientes.length} Cliente(s)
                                </button>
                                <Link to="/superadmin/plantillas" className="btn btn-secondary ml-2">
                                    Cancelar
                                </Link>
                            </div>
            {/* Modal de Confirmación */}
            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Asignación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Está seguro que desea asignar la plantilla <strong>{plantilla?.nombre}</strong> a los siguientes clientes?</p>
                    <ul>
                        {clientes
                            .filter(c => selectedClientes.includes(c.id))
                            .map(c => (
                                <li key={c.id}>{c.nombre}</li>
                            ))
                        }
                    </ul>
                    <div className="alert alert-warning mt-3">
                        <i className="fas fa-exclamation-triangle"></i> Se creará una copia completa de la plantilla para cada cliente seleccionado.
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirmModal(false)} disabled={submitting}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleAsignarConfirm} disabled={submitting}>
                        {submitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Asignando...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-check"></i> Confirmar Asignación
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Modal de Confirmación de Sincronización */}
            <Modal show={showSyncModal} onHide={() => !syncing && setShowSyncModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Actualización</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>¿Está seguro que desea actualizar la plantilla en <strong>{clientesAsignados.length}</strong> clientes asignados?</p>
                    <div className="alert alert-warning">
                        <i className="fas fa-exclamation-triangle"></i> Esto sobrescribirá la estructura actual de la plantilla en cada cliente.
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowSyncModal(false)} disabled={syncing}>
                        Cancelar
                    </Button>
                    <Button variant="warning" onClick={handleSincronizar} disabled={syncing}>
                        {syncing ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Actualizando...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-sync-alt"></i> Actualizar
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </SuperadminLayout>
    );
};

export default AsignarPlantillaClientes;
